import React, { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";

import InvoiceProduct from "./InvoiceProduct";
import InvoicePayments from "./InvoicePayments";
import InvoiceRetention from "./InvoiceRetention";
import InvoiceTotal from "./InvoiceTotal";

const InvoiceDetail = ({
  invoiceData,
  onInvoiceDataChange,
  payments,
  setPayments,
  productRows,
  setProductRows,
  productDescripcion,
  setProductDescripcion,
}) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_e, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ mx: "auto", mt: 3 }}>
      <Paper
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons={false}
          sx={{
            backgroundColor: "#1565C0",
            "& .MuiTab-root": {
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              minHeight: "48px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            },
            "& .Mui-selected": {
              backgroundColor: "#fff",
              color: "#1565C0",
              borderTop: "4px solid #1565C0",
              borderLeft: "4px solid #1565C0",
              borderRight: "4px solid #1565C0",
              borderBottom: "none",
              marginTop: "5px",
              marginLeft: "10px",
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab label="Productos" />
          <Tab label="Retenciones" />
          <Tab label="Formas de Pago" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {/* TAB PRODUCTOS */}
          {tabValue === 0 && (
            <InvoiceProduct
              rows={productRows}
              setRows={setProductRows}
              descripcion={productDescripcion}
              setDescripcion={setProductDescripcion}
              onProductDataChange={onInvoiceDataChange}
            />
          )}

          {/* TAB RETENCIONES */}
          {tabValue === 1 && <InvoiceRetention rows={productRows} />}

          {/* TAB PAGOS */}
          {tabValue === 2 && (
            <InvoicePayments
              totalPagar={Number(invoiceData?.total || 0)}
              payments={payments}
              setPayments={setPayments}
            />
          )}

          {/* TOTAL GENERAL */}
          <InvoiceTotal
            descripcion={productDescripcion}
            setDescripcion={setProductDescripcion}
            productTotals={{
              sub15: invoiceData?.subtotal15 || 0,
              sub5: invoiceData?.subtotal5 || 0,
              sub0: invoiceData?.subtotal0 || 0,
              descuento: invoiceData?.descuento_total || 0,
              iva15: invoiceData?.iva15 || 0,
              iva5: invoiceData?.iva5 || 0,
              ice: invoiceData?.ice || 0,
              total: invoiceData?.total || 0,
            }}
            accountTotals={null}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default InvoiceDetail;
